import { render } from "./Thankyou.vue?vue&type=template&id=4a5f9a7f&scoped=true"
import script from "./Thankyou.vue?vue&type=script&lang=js"
export * from "./Thankyou.vue?vue&type=script&lang=js"

import "./Thankyou.vue?vue&type=style&index=0&id=4a5f9a7f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5f9a7f"]])

export default __exports__